<template>
  <input
    v-bind="$attrs"
    type="text"
    inputmode="decimal"
    :value="display"
    @input="onInput"
    @focus="onFocus"
    @blur="onBlur"
    @keydown.up.prevent="bump(1)"
    @keydown.down.prevent="bump(-1)"
  />
</template>

<script>
import { formatNum, parseNum } from '@/util/number';

export default {
  name: 'NumberInput',
  inheritAttrs: false,
  props: {
    value: { type: [Number, String], default: null },
    decimals: { type: Number, default: 2 },
    grouping: { type: Boolean, default: true },
    min: { type: Number, default: null },
    max: { type: Number, default: null },
    step: { type: Number, default: 1 },
  },
  data() {
    return { display: '', focused: false };
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        // Jangan timpa apa yg lagi diketik user.
        if (this.focused) return;
        const num = parseNum(v);
        this.display = Number.isFinite(num)
          ? formatNum(num, this.decimals, this.grouping)
          : '';
      },
    },
  },
  methods: {
    // Bulatin ke desimal field biar 1.1 + 0.1 gak jadi 1.2000000000000002.
    clamp(value) {
      let num = value;
      if (this.min !== null && num < this.min) num = this.min;
      if (this.max !== null && num > this.max) num = this.max;
      const factor = 10 ** this.decimals;
      return Math.round(num * factor) / factor;
    },
    onInput(event) {
      // Sengaja gak diformat ulang di sini — format sambil ngetik bikin kursor
      // lompat. Clamp juga ditunda ke blur, biar ngetik "50" di field min=10
      // gak dilawan pas baru kepencet "5".
      this.display = event.target.value;
      const num = parseNum(event.target.value);
      this.$emit('input', Number.isFinite(num) ? num : null);
    },
    onFocus(event) {
      this.focused = true;
      const num = parseNum(this.value);
      this.display = Number.isFinite(num) ? String(num) : '';
      this.$nextTick(() => event.target.select());
    },
    onBlur() {
      this.focused = false;
      const num = parseNum(this.display);
      if (!Number.isFinite(num)) {
        this.display = '';
        this.$emit('input', null);
        return;
      }
      const clamped = this.clamp(num);
      this.display = formatNum(clamped, this.decimals, this.grouping);
      this.$emit('input', clamped);
    },
    bump(direction) {
      const num = parseNum(this.display);
      const next = this.clamp((Number.isFinite(num) ? num : 0) + direction * this.step);
      this.display = String(next);
      this.$emit('input', next);
    },
  },
};
</script>
